<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col class="text-right" cols="12" md="8">
                <v-btn
                @click="showAddDialog()"
                prepend-icon="mdi-plus"
                class="mt-1 rounded-lg"
                color="routesColor"
                height="40px"
                elevation="2">
                    Add Schedules
                </v-btn>
            </v-col>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="dt-container mt-2">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="sortedData"
                                :search="search"
                                :loading="loading"
                                :items-per-page="15"
                                :items-per-page-options="[15,30, 50, 100, -1]"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.compliance.compliance_name="{ item }">
                                <div class="text-truncate" style="max-width: 200px;">
                                    {{ item.compliance.compliance_name }}
                                </div>
                            </template>
                            <template v-slot:item.deadline="{ item }">
                                <span>{{ formatDate(item.deadline)}} </span>
                            </template>
                            <template v-slot:item.deadline_extension="{ item }">
                                <span>{{ formatDate(item.deadline_extension)}} </span>
                            </template>
                            <template v-slot:item.is_extended="{ item }">
                                <v-chip v-if="item.is_extended == true" size="small" color="green" variant="elevated">
                                    Yes
                                </v-chip>
                                <v-chip v-else size="small" color="gray">
                                    No
                                </v-chip>
                            </template>
                            <template v-slot:item.datecreated="{ item }">
                                <span>{{ formatDateTime(item.datecreated)}} </span>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                    <v-btn @click="showEditDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>

    <v-dialog v-model="confirmActivate" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want activate this semester and schoolyear?</div>
                <div class="font-weight-light mt-2">Note: If you activate this you will also deactivate the previously active semester and schoolyear</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmActivate = false" :disabled="loadingConfirmation" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loadingConfirmation" @click="activateItem()" color="darkGreen" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <SchedulesDialog ref="SchedulesDialog" @refresh="init()"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import SchedulesDialog from '../Dialogs/SchedulesDialog.vue';
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
    components: {
        SchedulesDialog
    },
    data(){
        return {
            data: [],
            search: null,
            loading: false,
            headers: [
                { title: 'Compliance', align: 'start', sortable: true, key: 'compliance.compliance_name' },
                { title: 'Deadline', align: 'start', sortable: true, key: 'deadline' },
                { title: 'Deadline Extension', align: 'start', sortable: true, key: 'deadline_extension' },
                { title: 'Term', align: 'start', sortable: true, key: 'term.name' },
                { title: 'Extend Deadline', align: 'start', sortable: true, key: 'is_extended' },
                { title: 'Date Created', align: 'start', sortable: true, key: 'datecreated' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            confirmActivate: false,
            loadingConfirmation: false,
            itemToActivate: null,
        }
    },
    methods: {
        init(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/schedules/getAllBySemesterSchoolyear/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.data = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        activateItem(){
            const { showSnackbar } = useSnackbar()
            this.loadingConfirmation = true
            const token = localStorage.getItem('aums-token')
            axios.patch(process.env.VUE_APP_SERVER_URL + '/semester-schoolyear/activate', this.itemToActivate,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 200){
                    this.init()
                    this.loadingConfirmation = false
                    this.confirmActivate = false
                    showSnackbar('Semester and Schoolyear successfully activated')
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        showAddDialog(){
            this.$refs.SchedulesDialog.initAdd()
        },
        showEditDialog(data){
            this.$refs.SchedulesDialog.initUpdate(data)
        },
        showConfirmDialog(data){
            this.itemToActivate = data
            this.confirmActivate = true
        }
    },
    computed: {
        sortedData() {
            return [...this.data].sort((a, b) => {
                return new Date(a.deadline) - new Date(b.deadline);
            });
        }
    },
    mounted(){
        this.init()
    }
})
</script>

<style scoped>

</style>